import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useStores } from "../../stores/root-store";
import { Modal } from "react-bootstrap";
import { ApiResponse, IModal } from "../../stores";

const ChangePassword = observer(({ show, setShowModal }: IModal) => {
  const { userStore } = useStores();
  const { changePassword } = userStore;

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    setIsFormValid(
      currentPassword &&
        newPassword.length > 5 &&
        newPassword === confirmNewPassword
        ? true
        : false
    );
  }, [currentPassword, newPassword, confirmNewPassword]);

  const submitCallback = (res: ApiResponse<boolean>) => {
    if (res && res.isSuccess && res.data) {
      setShowModal(false);
      ShowAlert.Success("Password changed successfully.");
    } else ShowAlert.Error("Request failed: " + res.message);
  };

  const handleFormSubmit = () => {
    if (!isFormValid) ShowAlert.Error("Please enter registered email.");
    else changePassword(currentPassword, newPassword, submitCallback);
  };

  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      centered
      scrollable
      dialogClassName="modal-sm"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4>Change Password</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <div className="panel-body">
                  <form autoComplete="off">
                    <div className="form-floating mb-3">
                      <input
                        type="password"
                        className="form-control"
                        id="cPwd"
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <label htmlFor="cPwd">Current Password</label>
                    </div>
                    <div className="form-floating">
                      <input
                        type="password"
                        className="form-control"
                        id="nPwd"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <label htmlFor="nPwd">New Password</label>
                    </div>
                    <div className="small text-muted">
                      *minimum 6 characters length
                    </div>
                    <div className="form-floating mb-3 mt-3">
                      <input
                        type="password"
                        className="form-control"
                        id="cnPwd"
                        placeholder="Confirm Password"
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                      />
                      <label htmlFor="cnPwd">Confirm Password</label>
                    </div>

                    <div className="btn-group d-flex mt-3">
                      <button
                        onClick={handleFormSubmit}
                        className="btn btn-default rounded-0 flex-fill"
                        disabled={!isFormValid}
                        type="button"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default ChangePassword;
